import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Waves, Clock, Wind, Droplets } from "lucide-react";

const ProfessorWeather = ({ weatherData }) => {
  if (!weatherData || weatherData.error) return null;
  return (
    <Card className="border-0 shadow-sm rounded-xl bg-gradient-to-r from-[#6697a4]/5 to-[#3d5a63]/5" data-testid="prof-weather-widget">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <Waves className="h-4 w-4 text-[#6697a4]" />
          <p className="font-semibold text-sm text-[#3d5a63]">Condições do Mar — Apúlia</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div className="bg-white rounded-xl p-3 text-center">
            <Waves className="h-5 w-5 text-[#6697a4] mx-auto" />
            <p className="text-lg font-bold text-[#3d5a63] mt-1">{weatherData.wave_height != null ? `${weatherData.wave_height}m` : "—"}</p>
            <p className="text-[10px] text-[#94A3B8]">Ondas</p>
          </div>
          <div className="bg-white rounded-xl p-3 text-center">
            <Clock className="h-5 w-5 text-[#6697a4] mx-auto" />
            <p className="text-lg font-bold text-[#3d5a63] mt-1">{weatherData.wave_period != null ? `${weatherData.wave_period}s` : "—"}</p>
            <p className="text-[10px] text-[#94A3B8]">Período</p>
          </div>
          <div className="bg-white rounded-xl p-3 text-center">
            <Wind className="h-5 w-5 text-[#6697a4] mx-auto" />
            <p className="text-lg font-bold text-[#3d5a63] mt-1">{weatherData.wind_speed != null ? `${weatherData.wind_speed} km/h` : "—"}</p>
            <p className="text-[10px] text-[#94A3B8]">Vento</p>
          </div>
          <div className="bg-white rounded-xl p-3 text-center">
            <Droplets className="h-5 w-5 text-[#6697a4] mx-auto" />
            <p className="text-lg font-bold text-[#3d5a63] mt-1">{weatherData.water_temp != null ? `${Math.round(weatherData.water_temp)}°C` : "—"}</p>
            <p className="text-[10px] text-[#94A3B8]">Água</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfessorWeather;
